export const success = {
  postsale: "La postventa se ha generado con éxito pero no se ha enviado",
  postsaleSend:
    "La postventa se ha generado con éxito y se ha enviado con éxito",
};


export const selectMessageStamp = (summary, snackbar) => {
  if (!summary) return;
  const {
    totalNotesRequested,
    validNotesProcessed,
    skippedNotes,
    skippedDetails
  } = summary;

  let message = "";

  if (validNotesProcessed > 0) {
    message = `Notas facturadas: ${validNotesProcessed}`;
  } 
  if (skippedNotes > 0) {
    message += `\nNotas no facturadas: ${skippedNotes}`;
  }
  if (skippedDetails?.length > 0) {
    const reasons = skippedDetails.join(", ");
    message += `\nMotivos: ${reasons}`;
  }

  let variant = "info";
  if (validNotesProcessed === totalNotesRequested) variant = "success";
  else if (validNotesProcessed > 0 && skippedNotes > 0) variant = "warning";
  else if (validNotesProcessed === 0) variant = "danger";

  snackbar(message, variant);
};